import { type UploadFileWithPreviewFormDataFragment } from '../../../../api/fragments';
import {
    type AppointmentModuleEmailContentInput,
    type AppointmentModuleEmailContentCustomerInput,
    type AppointmentModuleEmailContentFinderReservationInput,
} from '../../../../api/types';

export enum HeaderTabs {
    MainDetails = 'mainDetails',
    Email = 'email',
}

type EmailContentWithIntroImage = AppointmentModuleEmailContentInput & {
    introImage?: File | UploadFileWithPreviewFormDataFragment;
};

type EmailContentFinderReservationWithIntroImage = AppointmentModuleEmailContentFinderReservationInput & {
    introImage?: File | UploadFileWithPreviewFormDataFragment;
};

export type AppointmentEmailFormValues = {
    customer: {
        [key in keyof AppointmentModuleEmailContentCustomerInput]: EmailContentWithIntroImage;
    };
    salesPerson: {
        submitConfirmation: EmailContentWithIntroImage;
        finderReservation: EmailContentFinderReservationWithIntroImage;
    };
};
